var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlbums(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#030D45",
    fillRule: "evenodd",
    d: "M12 9.692c-2.196 0-5.201.172-7.048.293a1.21 1.21 0 00-1.133 1.072c-.134 1.204-.28 2.81-.28 4.02 0 1.21.146 2.816.28 4.02a1.21 1.21 0 001.133 1.072c1.847.12 4.852.293 7.048.293 2.196 0 5.201-.172 7.048-.293a1.21 1.21 0 001.133-1.072c.134-1.204.28-2.81.28-4.02 0-1.21-.146-2.816-.28-4.02a1.21 1.21 0 00-1.133-1.072c-1.846-.121-4.852-.293-7.048-.293zM4.85 8.45C6.699 8.33 9.75 8.154 12 8.154c2.251 0 5.302.175 7.15.296a2.748 2.748 0 012.56 2.438c.134 1.21.29 2.889.29 4.189 0 1.3-.156 2.98-.29 4.19a2.748 2.748 0 01-2.56 2.437C17.301 21.825 14.25 22 12 22c-2.251 0-5.302-.175-7.15-.296a2.748 2.748 0 01-2.56-2.438c-.134-1.21-.29-2.889-.29-4.19 0-1.3.156-2.978.29-4.189A2.748 2.748 0 014.85 8.45z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#030D45",
    fillRule: "evenodd",
    d: "M12 6.615c-1.6 0-3.752.076-5.2.135-.586.024-1.038.435-1.109.954-.06.436-.101.873-.101 1.22a.77.77 0 11-1.539 0c0-.45.053-.966.116-1.427.18-1.32 1.302-2.232 2.57-2.284 1.45-.06 3.628-.136 5.263-.136 1.635 0 3.814.076 5.263.136 1.268.052 2.39.965 2.57 2.284.063.461.116.977.116 1.426a.77.77 0 11-1.539 0 9.59 9.59 0 00-.101-1.219c-.071-.52-.523-.93-1.109-.954-1.448-.06-3.6-.135-5.2-.135z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#030D45",
    fillRule: "evenodd",
    d: "M12 3.538c-.955 0-2.194.054-3.182.106-.597.032-1.058.474-1.11 1.029-.04.416-.067.833-.067 1.173a.77.77 0 11-1.538 0c0-.41.032-.882.073-1.317.127-1.354 1.243-2.351 2.56-2.421A67.147 67.147 0 0112 2c.998 0 2.271.055 3.264.108 1.317.07 2.433 1.067 2.56 2.42.04.436.073.908.073 1.318a.77.77 0 11-1.538 0c0-.34-.028-.757-.067-1.173-.052-.555-.513-.997-1.11-1.029A65.708 65.708 0 0012 3.538zM9.18 15.077a.77.77 0 01.769-.77h4.102a.77.77 0 010 1.54H9.95a.77.77 0 01-.77-.77z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#030D45",
    fillRule: "evenodd",
    d: "M12 17.897a.77.77 0 01-.77-.769v-4.102a.77.77 0 011.54 0v4.102a.77.77 0 01-.77.77z",
    clipRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlbums);
export default __webpack_public_path__ + "static/media/albums.c7f681b8b7bffee3474c1b5baa6e76b8.svg";
export { ForwardRef as ReactComponent };